
export default function InfoPanelPink(props) {
    return (
        <div className="bg-gradient-to-br from-fuchsia-600 to-stone-900 w-[300px] sm:w-[400px] p-[2px] rounded-xl m-2">
            <div className="bg-stone-900 rounded-xl p-8 w-full h-full">
                <h1 className="text-fuchsia-600">{props.title}</h1>
                <br/>
                {props.text}
            </div>
        </div>
    );
}